
import { Bot } from "lucide-react";
import { Progress } from "@/components/ui/progress";

interface RecipeProcessingStatusInlineProps {
  isLoading: boolean;
  processingStage: string;
  progress: number;
}

const RecipeProcessingStatusInline = ({ isLoading, processingStage, progress }: RecipeProcessingStatusInlineProps) => {
  if (!isLoading) return null;

  return (
    <div className="mt-3 p-3 bg-muted rounded-md">
      <div className="flex items-center gap-2 mb-2">
        <Bot size={14} className="animate-pulse text-primary flex-shrink-0" />
        <p className="font-medium text-xs">{processingStage}</p>
      </div>
      <div className="space-y-2">
        <Progress value={progress} className="h-1.5" />
        <p className="text-xs text-center text-muted-foreground">
          {progress < 30 ? 'Analyzing...' : 
           progress < 60 ? 'Extracting...' : 
           progress < 90 ? 'Formatting...' : 'Almost done...'}
        </p>
      </div>
      <p className="text-xs text-muted-foreground mt-2 leading-tight">
        Please be patient while we extract the recipe details.
      </p>
    </div>
  );
};

export default RecipeProcessingStatusInline;
